//
//
//
//
//
//
//

export default {
  name: 'Carousel',
  props: {
    propsData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    imgActPadding: function imgActPadding() {
      if (!this.propsData.imgActPadding) {
        return '';
      }
      return "".concat(this.propsData.imgActPadding.pt || 0, "px ").concat(this.propsData.imgActPadding.pr || 0, "px ").concat(this.propsData.imgActPadding.pb || 0, "px ").concat(this.propsData.imgActPadding.pl || 0, "px");
    }
  }
};